var _defs, _style, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTalentsBig({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 71 71",
    width: 71,
    height: 71,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "es_arrow_back_big") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 96,
    height: 96,
    id: "img1",
    href: "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gVXBsb2FkZWQgdG86IFNWRyBSZXBvLCB3d3cuc3ZncmVwby5jb20sIEdlbmVyYXRvcjogU1ZHIFJlcG8gTWl4ZXIgVG9vbHMgLS0+DQo8c3ZnIGZpbGw9IiNmYmJjNTUiIHdpZHRoPSIyNHB4IiBoZWlnaHQ9IjI0cHgiIHZpZXdCb3g9IjAgMCAzMiAzMiIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPg0KPHRpdGxlPmFyY2hpdmUtYm94PC90aXRsZT4NCjxwYXRoIGQ9Ik0yOCAxLjI1aC0yNGMtMS41MTggMC4wMDItMi43NDggMS4yMzItMi43NSAyLjc1djQuMDAxYzAgMC40MTQgMC4zMzYgMC43NSAwLjc1IDAuNzVoMS4yNXYxOS4yNDdjMC4wMDIgMS41MTggMS4yMzIgMi43NDggMi43NSAyLjc1aDIwYzEuNTE4LTAuMDAyIDIuNzQ4LTEuMjMyIDIuNzUtMi43NXYtMTkuMjQ3aDEuMjVjMC40MTQtMCAwLjc1LTAuMzM2IDAuNzUtMC43NXYwLTQuMDAxYy0wLjAwMi0xLjUxOC0xLjIzMi0yLjc0OC0yLjc1LTIuNzVoLTB6TTI3LjI1IDI3Ljk5OGMtMC4wMDEgMC42OS0wLjU2IDEuMjQ5LTEuMjUgMS4yNWgtMjBjLTAuNjktMC4wMDEtMS4yNDktMC41Ni0xLjI1LTEuMjV2LTE5LjI0N2gyMi41ek0yOS4yNSA3LjI1MWgtMjYuNXYtMy4yNTFjMC4wMDEtMC42OSAwLjU2LTEuMjQ5IDEuMjUtMS4yNWgyNGMwLjY5IDAuMDAxIDEuMjQ5IDAuNTYgMS4yNSAxLjI1djB6TTEwIDE0Ljc1aDEyYzAuNDE0IDAgMC43NS0wLjMzNiAwLjc1LTAuNzVzLTAuMzM2LTAuNzUtMC43NS0wLjc1djBoLTEyYy0wLjQxNCAwLTAuNzUgMC4zMzYtMC43NSAwLjc1czAuMzM2IDAuNzUgMC43NSAwLjc1djB6Ij48L3BhdGg+DQo8L3N2Zz4="
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "active_talent_icon",
    href: "#img1",
    transform: "matrix(.74,0,0,.74,0,0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalentsBig);
export default __webpack_public_path__ + "static/media/talents_big.4a69e4b75cf5ef43813c089bdd552a0c.svg";
export { ForwardRef as ReactComponent };